import ViewInfo from './container';

export default ViewInfo;
